import { render, staticRenderFns } from "./tabBookingMaster.vue?vue&type=template&id=bcbd5cc0&scoped=true&"
import script from "./tabBookingMaster.vue?vue&type=script&lang=js&"
export * from "./tabBookingMaster.vue?vue&type=script&lang=js&"
import style0 from "./tabBookingMaster.vue?vue&type=style&index=0&id=bcbd5cc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbd5cc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcbd5cc0')) {
      api.createRecord('bcbd5cc0', component.options)
    } else {
      api.reload('bcbd5cc0', component.options)
    }
    module.hot.accept("./tabBookingMaster.vue?vue&type=template&id=bcbd5cc0&scoped=true&", function () {
      api.rerender('bcbd5cc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirImport/components/booking/tabs/tabBookingMaster.vue"
export default component.exports